const render = ({identifier}) => {
  return `
<script type="text/javascript">
  var PDregData = {};

  PDregData.SubMid     = "{pe_key}";
  PDregData.exit_url   = "{nextURL}";
  PDregData.first_name = "{firstName}";
  PDregData.last_name  = "{lastName}";
  PDregData.gender     = "{gender}";
  PDregData.dob        = "{dob_dashes_mmddyyyy}";
  PDregData.address1   = "{address1}";
  PDregData.city       = "{city}";
  PDregData.state      = "{state}";
  PDregData.zipcode    = "{zip}";
  PDregData.phone1     = "{phone_areaCode}";
  PDregData.phone2     = "{phone_prefix}";
  PDregData.phone3     = "{phone_suffix}";
  PDregData.email      = "{email}";
</script>
<script id="PD_Script_Configs" type="text/javascript" src="//www.pdapi.com/cs/JSI/v1/${identifier}/PDconfigs.js"></script>
<!-- END: AdQuire Inline, Permission Data -->
  `.trim()
};

export default render;